module.exports = __webpack_public_path__ + "Server-Busy.TentacleActive.0d9249bffeb1ff0bdd71f36f10e2ac0b.hashedasset.svg";